/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useRef, useState } from 'react';
import angleDown from '../assets/images/angle_up_down.svg';
import checkmarkSaved from '../assets/images/model/checkmark_saved.svg';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import close from '../assets/images/close-circle.svg';
import checkBox from '../assets/images/check_box.svg';
import 'react-h5-audio-player/lib/styles.css';
import './questionstypes.css';
import MediaComponent from './activity/MediaComponent';
const MultiChoice = ({ isEditing, question, index, actIndex, setNewActivities, isMore }) => {
  const isS3Url = (url) => {
    return url.includes('s3.amazonaws.com');
  };

  const isYouTubeUrl = (url) => {
    return url.includes('youtube.com') || url.includes('youtu.be');
  };
  const audioRef = useRef();
  const [textareaHeights, setTextareaHeights] = useState([40]);

  /* Long option */
  const getTextLengthClass = (text) => {
    return text.length > 30 ? 'long_option' : 'short_option';
  };
  const checkOption = (optionIndex, type = 'm') => {
    setNewActivities((oldAct) =>
      oldAct.map((act, ai) =>
        ai !== actIndex
          ? act
          : {
              ...act,
              questions: act.questions.map((q, qi) =>
                qi !== index
                  ? q
                  : {
                      ...q,
                      options: question.options.map((o, oi) =>
                        oi === optionIndex
                          ? {
                              ...o,
                              isCorrect: !o.isCorrect,
                            }
                          : {
                              ...o,
                              isCorrect: type === 't' ? false : o.isCorrect,
                            }
                      ),
                    }
              ),
            }
      )
    );
  };

  /*  */
  const handleInputChange = (e, questionIndex, optionIndex) => {
    const { value } = e.target;

    // Update textarea height if necessary
    const textarea = e.target;
    textarea.style.height = 'auto';
    const newHeight = textarea.scrollHeight;
    textarea.style.height = `${newHeight}px`;

    // setTextareaHeights((prevHeights) => {
    //   const newHeights = [...prevHeights];
    //   newHeights[questionIndex][optionIndex] = newHeight;
    //   return newHeights;
    // });

    // Update text value in questionss
    setNewActivities((oldAct) =>
      oldAct.map((act, ai) =>
        ai !== actIndex
          ? act
          : {
              ...act,
              questions: act.questions.map((q, qi) =>
                qi !== questionIndex
                  ? q
                  : {
                      ...q,
                      options: question.options.map((option, oi) =>
                        oi === optionIndex ? { ...option, text: value } : option
                      ),
                    }
              ),
            }
      )
    );
  };

  const getDragHandleHeight = (optionType, currentHeight) => {
    const defaultHeights = {
      text: 40,
      image: 148,
      video: 148,
      audio: 115,
    };
    const defaultHeight = defaultHeights[optionType] || 148;

    return defaultHeight + Math.max(currentHeight - 40, 0);
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;
    setNewActivities((oldAct) =>
      oldAct.map((act, ai) => {
        if (ai !== actIndex) return act;
        const copiedQuestions = JSON.parse(JSON.stringify(act)).questions;
        const sourceQuestion = copiedQuestions[source.droppableId];
        if (source.droppableId === destination.droppableId) {
          const reorderedOptions = Array.from(sourceQuestion.options);
          const [removed] = reorderedOptions.splice(source.index, 1);
          reorderedOptions.splice(destination.index, 0, removed);
          sourceQuestion.options = reorderedOptions;
        } else {
          return act;
        }
        return { ...act, questions: copiedQuestions };
      })
    );
  };

  /* Upload Media to Options */
  const handleMediaUpload = (imageFile, optionIndex, questionIndex) => {
    setNewActivities((oldAct) =>
      oldAct.map((act, ai) =>
        ai !== actIndex
          ? act
          : {
              ...act,
              questions: act.questions.map((q, qi) =>
                qi !== questionIndex
                  ? q
                  : {
                      ...q,
                      options: question.options.map((op, opIndex) =>
                        opIndex === optionIndex ? { ...op, url: imageFile } : op
                      ),
                    }
              ),
            }
      )
    );
  };

  /* ......................... */

  /* For Audio Source */
  const formatTime = (time) => {
    if (!time) return '0:00';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div key={index}>
        {['mcqs', 'truefalse'].includes(question.type) && (
          <Droppable
            droppableId={index.toString()}
            type='OPTIONS'
            className={`${question.type === 'truefalse' && 'flex-nowrap'}`}
          >
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className={`${'save_state_mcqs'}`}
                style={{ flexWrap: question.type === 'mcqs' ? 'wrap' : 'inherit' }}
              >
                {question.options.map((option, optionIndex) => (
                  <Draggable
                    key={option.order}
                    draggableId={`${index}-${option.order}`}
                    index={optionIndex}
                    isDragDisabled={!isEditing}
                  >
                    {(provided) => (
                      <>
                        {question.type === 'mcqs' ? (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            className={`orderlist-item ${
                              !isEditing ? 'save_state_border ' : 'border_none'
                            } ${!isEditing && getTextLengthClass(option.text)}`}
                          >
                            {isEditing ? (
                              <>
                                <RenderEditOption
                                  provided={provided}
                                  option={option}
                                  question={question}
                                  handleMediaUpload={handleMediaUpload}
                                  questionIndex={index}
                                  optionIndex={optionIndex}
                                  textareaHeights={textareaHeights}
                                  handleInputChange={handleInputChange}
                                  getDragHandleHeight={getDragHandleHeight}
                                  isS3Url={isS3Url}
                                  isYouTubeUrl={isYouTubeUrl}
                                  formatTime={formatTime}
                                  audioRef={audioRef}
                                  isEditing={isEditing}
                                />
                                <div className='check_cros_img'>
                                  <div
                                    style={{
                                      position: 'relative',
                                      right: '9px',
                                      width: '24px',
                                      height: '24px',
                                    }}
                                  >
                                    {question?.type === 'mcqs' && (
                                      <img
                                        className='cursor'
                                        src={close}
                                        alt='unselect'
                                        onClick={() => {
                                          setNewActivities((oldAct) =>
                                            oldAct.map((act, ai) =>
                                              ai !== actIndex
                                                ? act
                                                : {
                                                    ...act,
                                                    questions: act.questions.map((q, qi) =>
                                                      qi !== index
                                                        ? q
                                                        : {
                                                            ...q,
                                                            options: q.options.filter(
                                                              (o, oi) => oi !== optionIndex
                                                            ),
                                                          }
                                                    ),
                                                  }
                                            )
                                          );
                                        }}
                                      />
                                    )}
                                  </div>

                                  <img
                                    className={`check_true cursor ${
                                      option.isCorrect ? 'correct-option' : ''
                                    }`}
                                    src={checkBox}
                                    alt='select'
                                    value={option.text}
                                    onClick={() => {
                                      checkOption(optionIndex);
                                    }}
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                <RenderSavedOption
                                  provided={provided}
                                  option={option}
                                  questionIndex={index}
                                  optionIndex={optionIndex}
                                  textareaHeights={textareaHeights}
                                  getDragHandleHeight={getDragHandleHeight}
                                  isS3Url={isS3Url}
                                  isYouTubeUrl={isYouTubeUrl}
                                  formatTime={formatTime}
                                  audioRef={audioRef}
                                  isEditing={isEditing}
                                />
                                {option.isCorrect && (
                                  <img
                                    className='image_save_tick'
                                    src={checkmarkSaved}
                                    alt='check'
                                    value={option.text}
                                  />
                                )}
                              </>
                            )}
                          </div>
                        ) : (
                          <div
                            className='form-group option-wrapper'
                            style={{ width: '90%' }}
                            key={optionIndex}
                          >
                            {isEditing ? (
                              <>
                                {option.isCorrect && (
                                  <img
                                    className='option-close cursor'
                                    src={close}
                                    alt='close'
                                    style={{ top: '20%', right: '42px' }}
                                    onClick={() => checkOption(optionIndex, 't')}
                                  />
                                )}

                                <img
                                  className={`option-check cursor ${
                                    option.isCorrect ? 'correct-option' : ''
                                  }`}
                                  value={option.text}
                                  src={checkBox}
                                  alt='check'
                                  style={{ top: '20%', right: '10px' }}
                                  onClick={() => checkOption(optionIndex, 't')}
                                />
                                <label className='num'>{optionIndex === 0 ? 'T' : 'F'}</label>
                                <textarea
                                  style={{
                                    height: '40px',
                                    minHeight: '40px',
                                    width: '80%',

                                    border: '1px solid var(--Grey-600, #9D9690)',
                                  }}
                                  value={option.text}
                                  className='cutom_input'
                                  readOnly
                                />
                              </>
                            ) : (
                              <div
                                className='form-group  option-wrapper'
                                style={{ width: '90%' }}
                                key={optionIndex}
                              >
                                {option.isCorrect && (
                                  <img
                                    className='option-check cursor'
                                    value={option.text}
                                    src={checkmarkSaved}
                                    alt='check'
                                    style={{ top: '13%', right: '-11px' }}
                                  />
                                )}
                                <textarea
                                  style={{
                                    height: '32px',
                                    minHeight: '32px',
                                    width: '100%',
                                    paddingTop: '4px',
                                    paddingLeft: '12px',
                                    background: '#fff',
                                    border: '1px solid var(--Grey-600, #9D9690)',
                                  }}
                                  value={option.text}
                                  className='cutom_input'
                                  readOnly
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        )}
      </div>
    </DragDropContext>
  );
};
const RenderEditOption = ({
  option,
  questionIndex,
  optionIndex,
  handleInputChange,
  handleMediaUpload,
  isEditing,
  question,
}) => {
  const renderMedia = ['image', 'video', 'audio'].includes(option.type);
  return (
    <>
      <div className='parent_input_with_image mcqs_border'>
        <div className='parent_input'>
          <div className='order-number'>
            <span className='order-number-box'>{String.fromCharCode(65 + optionIndex)}</span>
          </div>
          <textarea
            id={`textarea-${questionIndex}-${optionIndex}`}
            className='orderlist-input'
            readOnly={question?.type === 'turefalse'}
            placeholder={option.type === 'text' ? `Add text` : `Add text (optional)`}
            rows={1}
            value={option.text}
            onChange={(e) => handleInputChange(e, questionIndex, optionIndex)}
            style={{
              height: `40px`,
            }}
          />
        </div>
        {renderMedia && (
          <MediaComponent
            media={option}
            isEditing={isEditing}
            onSuccess={(fileUrl, alt, attribution) => {
              handleMediaUpload(fileUrl, optionIndex, questionIndex);
            }}
          />
        )}
      </div>
    </>
  );
};

const RenderSavedOption = ({ option, isEditing, optionIndex }) => {
  const renderMedia = ['image', 'video', 'audio'].includes(option.type);
  return (
    <>
      <div className='parent_input_with_image'>
        <div className='parent_input' style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className='order-number order-number_save'>
              <span className='order-number-box order-number-box_save checkbox_border_color'>
                {option.order || String.fromCharCode(65 + optionIndex)}
              </span>
            </div>
            {option.text && (
              <div className='orderlist-input option_save_state option_saved_1'>{option.text}</div>
            )}
          </div>
          {renderMedia && <MediaComponent media={option} isEditing={isEditing} />}
        </div>
      </div>
    </>
  );
};

export default MultiChoice;
